





























import { Component, Vue, Prop } from 'vue-property-decorator'

import Booking from '@/models/booking'
import Payment from '@/models/payment'

import { longDateFormat } from '@/globalFilters'
import MasterPaymentInfoService from '@/services/PaymentInfo/MasterPaymentInfoService'

import CreditCardIcon from './CreditCardIcon.vue'

@Component({
  components: {
    CreditCardIcon,
  },
})
export default class PaymentHeader extends Vue {
  @Prop() payment!: Payment
  @Prop() booking!: Booking

  dateFormat = longDateFormat

  get paymentRecieverName(): string {
    return this.payment.cardHolder || 'Someone'
  }

  get paymentInfo(): string {
    return new MasterPaymentInfoService(this.payment).call()
  }
}
